(function () {
    'use strict';

    angular
        .module('visualGuidelinesControllers')
        .controller('VisualGuidelinesController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService'];

    function Controller($scope, $state, topBarService) {

        topBarService.setModule('Visual Guidelines');
        topBarService.setTitleAndIcon('Home', 'fa fa-codepen');

        if (!$scope.authenticatedUser.User.IsInAdministrationGroup) {
            $state.go('root');
        }
    }
})();